<template>
<div>
    <test-page-header
        :title="testBeingPassing.name"
        :is-one-line-title="false"
        :return-button="returnButton"
        :is-show-navigation="!isPublicForm"
    />
    <div v-html="testBeingPassing.instruction">
    </div>
    <div v-if="testBeingPassingSession" class="mt-2">
        <div class="notification is-warning is-light test-continuation-notification">
            <i class="fas fa-exclamation-circle is-warning mr-1 fa-lg"></i>
            <span v-html="testContinuationText"></span>
            <span class="ml-auto">
                <i class="fa fa-spinner fa-spin" v-if="requestsProgress.test.show"></i>
                <a
                    v-else
                    class="has-text-link"
                    :class="{
                        'is-disabled': isAnyRequestInProgress,
                        'has-text-link': !isAnyRequestInProgress,
                    }"
                    @click="continueTest"
                >
                    {{ trans.show_form.continue_test_button }}
                </a>
            </span>
        </div>
    </div>
    <div class="test-start-confirmation-form-container mt-2">
        <button
            v-if="isCanStartNewSession"
            class="button is-link"
            @click="startNewTest"
            :disabled="requestsProgress.test.show"
            :class="{'is-loading': requestsProgress.test.show }"
        >
            {{ trans.show_form.start_test_button }}
        </button>
    </div>
</div>
</template>

<script>
import TestPageHeader from "../TestPageHeader";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestStartForm",
    components: {TestPageHeader},
    data() {
        return {
            isManagementDropdownActive: false,
        };
    },
    computed: {
        ...mapGetters('tests', [
            'testBeingPassing',
            'trans',
            'requestsProgress',
            'testBeingPassingSession',
            'isAnyRequestInProgress',
            'isCanStartNewSession',
            'isPublicForm',
        ]),
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnToTestListPage,
            }
        },
        testContinuationText() {
            let text = this.trans.show_form.test_continuation_notification_text;

            return this.replaceWildcards(text, {
                datetime: this._dateTimeFormat(this.testBeingPassingSession.created_at.replace(' ', 'T') + 'Z'),
            });
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestListPage',
            'startTest',
        ]),
        startNewTest() {
            this.beginTesting(true);
        },
        continueTest() {
            this.beginTesting();
        },
        beginTesting(isForcedNew = false) {
            if (this.isAnyRequestInProgress) {
                return;
            }

            this.startTest({
                test: this.testBeingPassing,
                forceNew: isForcedNew,
            });
        },
    }
}
</script>

<style scoped>
    .test-continuation-notification {
        display: flex;
        align-items: center;
    }
</style>